import { render, staticRenderFns } from "./select-customer.vue?vue&type=template&id=35c7c47d&"
import script from "./select-customer.vue?vue&type=script&lang=js&"
export * from "./select-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports